module.exports = __webpack_public_path__ + "static/media/recova-logo.0ab1ebd8.svg";